"use client";

import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { ModeToggle } from "@/components/theme-toggle";
import Image from "next/image";
import { useTranslations } from "next-intl";
import { LanguageSwitcher } from "@/components/language-switcher";

export function SiteHeader() {
  const t = useTranslations("HomePage.SiteHeader");
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 60) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background/95 backdrop-blur-md shadow-sm border-b border-border/50 py-3 px-6 md:px-12"
          : "bg-transparent py-5 px-6 md:px-12"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between">
        <Link href="/" className="flex items-center gap-2.5 group">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl overflow-hidden shadow-sm group-hover:scale-105 transition-transform">
            <Image
              src="/career-loop-logo.png"
              alt={t("brandAlt")}
              width={40}
              height={40}
              className="h-full w-full object-cover"
            />
          </div>
          <span className="text-xl font-extrabold tracking-tight text-foreground bg-gradient-to-r from-foreground via-foreground to-primary bg-clip-text">
            {t("brand")}
          </span>
        </Link>
        <div className="flex items-center gap-3">
          <LanguageSwitcher />
          <ModeToggle />
          <Link href="/login">
            <Button
              variant="outline"
              size="sm"
              className="font-medium hover:border-primary/50 hover:text-primary transition-colors"
            >
              {t("login")}
            </Button>
          </Link>
        </div>
      </nav>
    </header>
  );
}
